import React from "react";
export var isObject = function(value) {
    return value !== null && (value === null || value === void 0 ? void 0 : value.constructor) === Object;
};
export var hasMembers = function(value) {
    if (Array.isArray(value)) {
        return value.length > 0;
    }
    return Object.keys(value).length > 0;
};
export var isFunction = function(value) {
    return typeof value === 'function';
};
export var isBoolean = function(value) {
    return typeof value === 'boolean';
};
export var isString = function(value) {
    return typeof value === 'string';
};
export var isEmptyString = function(value) {
    return isString(value) && value.trim().length === 0;
};
export var isDate = function(value) {
    return Object.prototype.toString.call(value) === '[object Date]';
};
export var isReactElement = function(value) {
    return React.isValidElement(value);
};
export var isTruthy = function(value) {
    return Boolean(value) || value === 0;
};
export var isRefObject = function(value) {
    return typeof value === 'object' && value.hasOwnProperty('current');
};
